import { Skeleton, Stack, useMantineTheme } from '@mantine/core';

import { GradientBorder } from '../../../../../../../../shared/components/GradientBorder';

export function ResponseProjectDetailBlocksLoading() {
  const theme = useMantineTheme();
  return (
    <Stack w="100%" spacing="04">
      {Array.from({ length: 3 }).map((_, index) => (
        <GradientBorder
          borderRadius={12}
          gradient={theme.other.gradients.background2}
          key={index}
        >
          <Stack w="100%" p="04" spacing="02">
            <Skeleton h={20} w="10%" radius="lg" />
            <Skeleton h={20} w="30%" radius="lg" />
            <Skeleton h={20} w="20%" radius="lg" />
          </Stack>
        </GradientBorder>
      ))}
    </Stack>
  );
}
